//templates
export const TEMPLATE_DRAFT_INIT = 'TEMPLATE_DRAFT_INIT'
export const TEMPLATE_DRAFT_UPDATE = 'TEMPLATE_DRAFT_UPDATE'
export const TEMPLATE_DRAFT_SELECTION_SET = 'TEMPLATE_DRAFT_SELECTION_SET'
export const TEMPLATE_DRAFT_SELECTION_ALL = 'TEMPLATE_DRAFT_SELECTION_ALL'
export const TEMPLATE_DRAFT_SELECTION_CLEAR = 'TEMPLATE_DRAFT_SELECTION_CLEAR'
export const TEMPLATE_DRAFT_BOT_FIELD_UPDATE = 'TEMPLATE_DRAFT_BOT_FIELD_UPDATE'
export const TEMPLATE_DRAFT_BOT_FIELDS_SORT = 'TEMPLATE_DRAFT_BOT_FIELDS_SORT'

export const TEMPLATES_INSTALLATION_STATUS_UPDATE = 'TEMPLATES_INSTALLATION_STATUS_UPDATE'

export const TEMPLATEINSTALLATIONS_FETCH_RESPONSE = 'TEMPLATEINSTALLATIONS_FETCH_RESPONSE'
export const TEMPLATEINSTALLATIONS_DEACTIVATE_REQUEST = 'TEMPLATEINSTALLATIONS_DEACTIVATE_REQUEST'
export const TEMPLATEINSTALLATIONS_ACTIVATEFORPAGE_REQUEST =
  'TEMPLATEINSTALLATIONS_ACTIVATEFORPAGE_REQUEST'

export const TEMPLATE_WARN_PROTECTION = 'TEMPLATE_WARN_PROTECTION'

//template installation
export const CONTENTMAP_CURRENT_GETFOLDERS_REQUEST = 'CONTENTMAP_CURRENT_GETFOLDERS_REQUEST'
export const CONTENTMAP_CURRENT_GETFOLDERS_ERROR = 'CONTENTMAP_CURRENT_GETFOLDERS_ERROR'
export const CONTENTMAP_CURRENT_GETFOLDERS_RESPONSE = 'CONTENTMAP_CURRENT_GETFOLDERS_RESPONSE'
